import { Grid, Typography, withStyles } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import React from 'react';

const ItemsWithCheckMark = ({ classes, items, checkColor = 'primary' }) => {
  return (
    <Grid container>
      {items.map((learningItem, i) => {
        return (
          <Grid item xs={12} key={i} className={classes.learningItems}>
            <ItemWithCheck data={learningItem} checkColor={checkColor} />
          </Grid>
        );
      })}
    </Grid>
  );
};

const styles = theme => ({
  learningItems: {
    paddingBottom: theme.spacing(1)
  }
});

export default withStyles(styles)(ItemsWithCheckMark);

const ItemWithCheck = ({ data, checkColor }) => (
  <Grid container>
    <Grid item xs={2} md={2} xl={1}>
      <Check color={checkColor} />
    </Grid>
    <Grid item xs={10} md={10} xl={7}>
      <Typography variant={'body1'}>{data}</Typography>
    </Grid>
  </Grid>
);
